import { render, staticRenderFns } from "./SCB.vue?vue&type=template&id=5f7708b6&"
import script from "./SCB.vue?vue&type=script&lang=js&"
export * from "./SCB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports